// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader-module--root--2bMPH","loaderText":"Loader-module--loaderText--djBTY","hide":"Loader-module--hide--3NNlS"};